import * as React from "react"
import { Box } from "@mui/material"
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"


/** The market of the row.
 *
 * `DIPI_CUSTOMER_MAIN_SITE.country` is a **market**, not a country, and `ES_CA` is a real value next
 * to `ES`. That is not a reason to print the raw code, though: `translateCountryName` treats `ES_CA`
 * as a first-class case ("Canary Islands", with the ES flag), so the full name is safe here — and
 * this table only holds Market, Site and actions, so there is room for it.
 *
 * Anything it does not recognise answers `'Unknown'`, and then the code is shown as stored. Same
 * fallback as `Admin/UserActivites/Content/Table/columns/country.jsx`.
 */
export default function marketColumn() {
    return {
        name: 'country', label: 'Market',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRenderLite: value => {
                const name = translateCountryName(value)
                return <Box display="flex" justifyContent="center">
                    <LabelCountry country={value} label={name === 'Unknown' ? value : name} />
                </Box>
            }
        }
    }
}
